import {
  Autocomplete,
  Box,
  Button,
  MenuItem,
  Radio,
  Rating,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as api from '../services/api'

import styles from "./healthAss.module.css";
import CircleIcon from "@mui/icons-material/Circle";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import back from '../../assets/icons/back.svg';
import one from "../../assets/icons/assessment/one.svg";
import two from "../../assets/icons/assessment/two.svg";
import three from "../../assets/icons/assessment/three.svg";
import four from "../../assets/icons/assessment/four.svg";
import Loader from "../../components/Loader";
import CustomizedModal from '../../components/modal/CustomizedModal';
import { useDispatch, useSelector } from "react-redux";
import { menuActive } from "../../store/menuSlice";
import { user_data } from "../../store/authSlice";
import ModalConfirm from "../../components/modal/ModalConfirm";

const StyledRating = withStyles({
  iconFilled: {
    color: "#478F96",
  },
  iconHover: {
    color: "#478F96",
  },
})(Rating);

const GreenRadio = withStyles({
  root: {
    color: "#696984",
    "&$checked": {
      color: "#478F96",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />)

function MentalHealthAssessment() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false);
  
  // const authen = useSelector((state) => state.auth.user_data)

  const [information, setInformation] = useState({})
  const [openModalConfirm, setOpenModalConfirm] = useState(false)

  const [data, setData] = useState({
    title_name: "", //ยศ
    department_name: "", //สังกัด
    department_code: "",
    fname: "", //ชื่อ
    lname: "", //นามสกุล
    sex: "", //เพศ
    age: "", //อายุ
    pid: "", //เลขบัตรประชาชน
    phone: "", //หมายเลขโทรศัพท์
  });

  const [evaluationType, setEvaluationType] = useState(false)

  const [evaluate_rq1, setEvaluate_rq1] = useState(0);
  const [evaluate_rq2, setEvaluate_rq2] = useState(0);
  const [evaluate_rq3, setEvaluate_rq3] = useState(0);

  const [evaluate_burnout1, setEvaluate_burnout1] = useState("");
  const [evaluate_burnout2, setEvaluate_burnout2] = useState("");
  const [evaluate_burnout3, setEvaluate_burnout3] = useState("");
  const [evaluate_burnout4, setEvaluate_burnout4] = useState("");
  const [evaluate_burnout5, setEvaluate_burnout5] = useState("");
  const [evaluate_burnout6, setEvaluate_burnout6] = useState("");

  const [evaluate_st1, setEvaluate_st1] = useState(null);
  const [evaluate_st2, setEvaluate_st2] = useState(null);
  const [evaluate_st3, setEvaluate_st3] = useState(null);
  const [evaluate_st4, setEvaluate_st4] = useState(null);
  const [evaluate_st5, setEvaluate_st5] = useState(null);

  const handleCloseCancelModal = () => setShowCancelModal(false);

  const optionalList = [1, 2, 3, 4]
  const optionalListSt5 = [0, 1, 2, 3]

  const [gender, setGender] = useState([])
  const [titlename, setTitlename] = useState([])
  const [department, setDepartment] = useState([])

  if (!location.state) {
    location.state = { button: "1" };
  }

  const [isValidphone, setIsValidphone] = useState(false);
  const [isValidpid, setIsValidpid] = useState(false);

  useEffect(() => {
    dispatch(menuActive('แบบประเมินสุขภาพ'))
    // dispatch(menuActive('แบบประเมินทั้งหมด'))
    getProfile()

    findGender()
    findTitleName()
    findDepartmentFixToken()
  }, [])

  const confirmCancelChanges = () => {
    setShowCancelModal(false);
    navigate('/assessment'); 
  };

  const handleButton = (number) => {
    navigate('/mentalHealthAssessment', { state: { button: number } });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleChangePID = (e) => {
    setData({ ...data, 'pid': e.target.value });
    const regex = /^\d{13}$/;
    setIsValidpid(regex.test(e.target.value));
  }

  const handleChangePhone = (e) => {
    setData({ ...data, 'phone': e.target.value });
    const regex = /^\d{10}$/;
    setIsValidphone(regex.test(e.target.value));
  }

  const handleChangeAge = (e) => {
    const maxLength = 2;
    const numericRegex = /^[0-9]*$/;
    if (e.target.value.length <= maxLength && numericRegex.test(e.target.value)) {
      setData({ ...data, 'age': e.target.value });
    }
  }

  const saveAssessment = () => {
    // console.log(evaluate_st1 + evaluate_st2 + evaluate_st3 + evaluate_st4 + evaluate_st5)
    let result = evaluate_st1 + evaluate_st2 + evaluate_st3 + evaluate_st4 + evaluate_st5

    if (result <= 7) {
      let inform = {
        "title_name": data['title_name'],
        "department_code": data['department_code'],
        "firstname": data['fname'],
        "lastname": data['lname'],
        "gender": data['sex'],
        "age": data['age'],
        "pid": data['pid'],
        "phone": data['phone'],
        "evaluate_rq": [
          {
            "question": "1) ฉันเอาชนะอุปสรรคปัญหาต่าง ๆ ในชีวิตได้",
            "score": evaluate_rq1
          },
          {
            "question": "2) ฉันมีกำลังใจและได้รับการสนับสนุนจากคนรอบข้าง",
            "score": evaluate_rq2
          },
          {
            "question": "3) ฉันจัดการกับปัญหาและความเครียดของตนเองได้",
            "score": evaluate_rq3
          }
        ],
        "evaluate_burnout": [
          {
            "question": "1) ท่านรู้สึกอ่อนล้าทางจิตใจ",
            "score": evaluate_burnout1
          },
          {
            "question": "2) ท่านรู้สึกขาดแรงใจ/ ความกระตือรือร้น",
            "score": evaluate_burnout2
          },
          {
            "question": "3) ท่านรู้สึกไม่ดีกับคนรอบข้าง",
            "score": evaluate_burnout3
          },
          {
            "question": "4) ท่านรู้สึกไม่อยากสนใจคนรอบข้าง",
            "score": evaluate_burnout4
          },
          {
            "question": "5) ท่านรู้สึกไม่มีความสุขในการทำงาน",
            "score": evaluate_burnout5
          },
          {
            "question": "6) ท่านรู้สึกไม่ประสบความสำเร็จเท่าที่ควร",
            "score": evaluate_burnout6
          }
        ],
        "evaluate_st5": [
          {
            "question": "1) มีปัญหาการนอน นอนไม่หลับ หรือนอนมาก",
            "score": evaluate_st1
          },
          {
            "question": "2) มีสมาธิน้อยลง",
            "score": evaluate_st2
          },
          {
            "question": "3) หงุดหงิด กระวนกระวาย ว้าวุ่นใจ",
            "score": evaluate_st3
          },
          {
            "question": "4) รู้สึกเบื่อหน่าย เซ็ง",
            "score": evaluate_st4
          },
          {
            "question": "5) ไม่อยากพบปะผู้คน",
            "score": evaluate_st5
          }
        ]
      }
      // console.log(inform)
      // evaluation(inform)
      setInformation(inform)
      setOpenModalConfirm(true)

    } else {
      let information = {
        "title_name": data['title_name'],
        "department_code": data['department_code'],
        "firstname": data['fname'],
        "lastname": data['lname'],
        "gender": data['sex'],
        "age": data['age'],
        "pid": data['pid'],
        "phone": data['phone'],
        "evaluate_rq1": evaluate_rq1,
        "evaluate_rq2": evaluate_rq2,
        "evaluate_rq3": evaluate_rq3,
        "evaluate_burnout1": evaluate_burnout1,
        "evaluate_burnout2": evaluate_burnout2,
        "evaluate_burnout3": evaluate_burnout3,
        "evaluate_burnout4": evaluate_burnout4,
        "evaluate_burnout5": evaluate_burnout5,
        "evaluate_burnout6": evaluate_burnout6,
        "evaluate_st1": evaluate_st1,
        "evaluate_st2": evaluate_st2,
        "evaluate_st3": evaluate_st3,
        "evaluate_st4": evaluate_st4,
        "evaluate_st5": evaluate_st5
      }
      navigate('/depressionAssessment', { state: information })
    }
  }

  const findGender = async () => {
    setLoading(true)
    let res = await api.gender()
    setLoading(false)
    if (res) {
      if (res['data']['code'] == 200) {
        setGender(res['data']['data'])
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const findTitleName = async () => {
    setLoading(true)
    let res = await api.titleName()
    setLoading(false)
    if (res) {
      if (res['data']['code'] == 200) {
        let option = []
        for (let i = 0; i < res['data']['data'].length; i++) {
          if (res['data']['data'][i]) {
            option.push({
              key: res['data']['data'][i]['value'],
              label: res['data']['data'][i]['name']
            })
          }
          const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
          setTitlename(unique)
        }
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const findDepartmentFixToken = async () => {
    setLoading(true)
    let res = await api.findDepartmentFixToken()
    setLoading(false)
    if (res) {
      if (res['data']['code'] == 200) {
        let option = []
        for (let i = 0; i < res['data']['data'].length; i++) {
          if (res['data']['data'][i]) {
            option.push({
              key: res['data']['data'][i]['department_code'],
              label: res['data']['data'][i]['department_name']
            })
          }
          const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
          setDepartment(unique)
        }
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const getProfile = async () => {
    setLoading(true)
    let res = await api.profile()
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        // console.log(res['data']['data'])
        // dispatch(user_data(res['data']['data']))

        let detail = res['data']['data']
        setEvaluationType(detail['evaluation_mental_health']) //สถานะการทำแบบประเมิน
        setData({
          ...data,
          'title_name': detail['titlename'],
          'department_name': detail['department']?.['department_name'],
          'department_code': detail['department']?.['department_code'],
          'fname': detail['firstname'],
          'lname': detail['lastname'],
          'sex': detail['gender'],
          'pid': detail['card_id'],
          'phone': detail['phone'],
        });
        // console.log(detail)
        const regex = /^\d{13}$/;
        setIsValidpid(regex.test(detail['card_id']));

        const regexPhone = /^\d{10}$/;
        setIsValidphone(regexPhone.test(detail['phone']));

      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  return (
    <>
        {/* Cancel Modal */}
        {showCancelModal && (
            <CustomizedModal
            onClose={handleCloseCancelModal}
            apiCall={confirmCancelChanges}
            confirmMessage="ยกเลิกการเปลี่ยนแปลง?"
            confirmButtonText="ตกลง"
            />
        )}

      {openModalConfirm &&
        <ModalConfirm
          data={information}
          onFinished={() => {
            // console.log('onFinished')
            setEvaluate_rq1(0)
            setEvaluate_rq2(0)
            setEvaluate_rq3(0)
            setEvaluate_burnout1('')
            setEvaluate_burnout2('')
            setEvaluate_burnout3('')
            setEvaluate_burnout4('')
            setEvaluate_burnout5('')
            setEvaluate_burnout6('')
            setEvaluate_st1(null)
            setEvaluate_st2(null)
            setEvaluate_st3(null)
            setEvaluate_st4(null)
            setEvaluate_st5(null)

            getProfile()
          }}
          onClose={() => { setOpenModalConfirm(false) }}
        />
      }

      <Loader loading={loading} />

      {/* <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gridGap: '10px',
        marginBottom: '10px'
      }}>
        <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
        <Box sx={{
          cursor: 'pointer'
        }}
          onClick={() => { setShowCancelModal(true) }}
        >กลับไป แบบประเมินสุขภาพ</Box>
      </Box> */}

      {/* Back Button */}
          <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={() => { setShowCancelModal(true) }}>
              <img src={back} alt="Previous" className={styles.directIcon} />
              กลับไป แบบประเมินสุขภาพ
      </Box>

      <Box
        sx={{
          fontWeight: 600,
          color: "#478F96",
          "@media (max-width: 800px)": {
            textAlign: "center",
          },
        }}
      >
        แบบประเมินสุขภาพใจ
      </Box>

      <Box sx={{ display: "flex", margin: "10px 0" }}>
        {location.state.button === "1" ? (
          <></>
        ) : null}
        {location.state.button === "2" ? (
          <Box>
            {/* Back Button */}
            <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={() => { handleButton("1") }}>
                    <img src={back} alt="Previous" className={styles.directIcon} />
                    ย้อนกลับ
              </Box>
          </Box>
        ) : null}
        {location.state.button === "3" ? (
          <Box>
            {/* Back Button */}
            <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={() => { handleButton("2") }}>
                    <img src={back} alt="Previous" className={styles.directIcon} />
                    ย้อนกลับ
              </Box>
          </Box>
        ) : null}
        {location.state.button === "4" ? (
          <Box>
            {/* Back Button */}
            <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={() => { handleButton("3") }}>
                    <img src={back} alt="Previous" className={styles.directIcon} />
                    ย้อนกลับ
              </Box>
          </Box>
        ) : null}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", margin: "10px 0" }}>
        {location.state.button === "1" ? (
          <img className={styles.number} src={one} />
        ) : null}
        {location.state.button === "2" ? (
          <img className={styles.number} src={two} />
        ) : null}
        {location.state.button === "3" ? (
          <img className={styles.number} src={three} />
        ) : null}
        {location.state.button === "4" ? (
          <img className={styles.number} src={four} />
        ) : null}
      </Box>

      <Box>
        {location.state.button === "1" ? (
          <Box
            sx={{
              display: "grid",
              gridGap: "20px",
              marginTop: "20px",
            }}
          >
            <Box
              sx={{
                fontWeight: 600,
                "@media (max-width: 800px)": {
                  fontSize: "14px",
                },
              }}
            >
              ส่วนที่ 1 : ข้อมูลทั่วไป
            </Box>
            <Box
              sx={{
                border: "1px solid #AEB4DD",
                borderRadius: "5px",
                padding: "20px",
              }}
            >
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gridGap: "20px",
                  "@media (max-width: 800px)": {
                    gridTemplateColumns: "1fr",
                  },
                }}
              >
                <Box>
                  <Typography>ยศ</Typography>
                  <Autocomplete
                    fullWidth
                    size='small'
                    options={titlename}
                    value={data["title_name"]}
                    onChange={(e, value) => {
                      setData({ ...data, 'title_name': value?.['label'] });
                    }}
                    renderInput={(params) =>
                      <TextField {...params}
                        placeholder="เลือกยศ"
                      />
                    }
                  />
                </Box>

                <Box>
                  <Typography>สังกัด</Typography>
                  <Autocomplete
                    fullWidth
                    size='small'
                    options={department}
                    value={data["department_name"]}
                    onChange={(e, value) => {
                      setData({ ...data, 'department_name': value?.['label'], 'department_code': value?.['key'] });
                    }}
                    renderInput={(params) =>
                      <TextField {...params}
                        placeholder="เลือกสังกัด"
                      />
                    }
                  />
                </Box>

                <Box>
                  <Typography>ชื่อ</Typography>
                  <TextField
                    placeholder="ชื่อ"
                    size="small"
                    fullWidth
                    value={data["fname"]}
                    name={"fname"}
                    onChange={handleChange}
                  />
                </Box>

                <Box>
                  <Typography>นามสกุล</Typography>
                  <TextField
                    placeholder="นามสกุล"
                    size="small"
                    fullWidth
                    value={data["lname"]}
                    name={"lname"}
                    onChange={handleChange}
                  />
                </Box>

                <Box>
                  <Typography>เพศ</Typography>
                  <Select
                    size="small"
                    fullWidth
                    value={data["sex"] || "null"}
                    name={"sex"}
                    onChange={handleChange}
                  >
                    <MenuItem value="null" disabled>
                      เลือกเพศ
                    </MenuItem>
                    {gender.map((i, idx) => (
                      <MenuItem key={idx} value={i['value']}>{i['name']}</MenuItem>
                    ))}
                  </Select>
                </Box>

                <Box>
                  <Typography>อายุ</Typography>
                  <TextField
                    type="number"
                    placeholder="อายุ"
                    size="small"
                    fullWidth
                    value={data["age"]}
                    name={"age"}
                    onChange={handleChangeAge}
                  />
                </Box>

                <Box>
                  <Typography>เลขบัตรประชาชน</Typography>
                  <TextField
                    type="number"
                    placeholder="กรอกเลขบัตรประชาชน 13 หลัก"
                    size="small"
                    fullWidth
                    value={data["pid"]}
                    name={"pid"}
                    onChange={handleChangePID}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: isValidpid ? '' : 'red',
                        }
                      },
                    }}
                  />
                </Box>

                <Box>
                  <Typography>หมายเลขโทรศัพท์</Typography>
                  <TextField
                    type="number"
                    placeholder="กรอกเบอร์โทรศัพท์"
                    size="small"
                    fullWidth
                    value={data["phone"]}
                    name={"phone"}
                    onChange={handleChangePhone}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: isValidphone ? '' : 'red',
                        }
                      },
                    }}
                  />
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                textAlign: "center",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  width: "150px",
                  "@media (max-width: 800px)": {
                    width: "100px",
                  },
                }}
                onClick={() => {
                  // if (evaluationType === true) {
                  //   alert('เลขบัตรประชาชนของท่าน มีการทำแบบประเมินนี้ไปแล้ว')
                  // } else {
                  // console.log(data)
                  if (!data['title_name']) {
                    return alert('กรุณาเลือกยศ')
                  }
                  if (!data['department_name']) {
                    return alert('กรุณาเลือกสังกัด')
                  }
                  if (!data['fname']) {
                    return alert('กรุณากรอกชื่อ')
                  }
                  if (!data['lname']) {
                    return alert('กรุณากรอกนามสกุล')
                  }
                  if (!data['sex']) {
                    return alert('กรุณาเลือกเพศ')
                  }
                  if (!data['age']) {
                    return alert('กรุณากรอกอายุ')
                  }
                  if (!data['pid']) {
                    return alert('กรุณากรอกเลขบัตรประชาชน')
                  }
                  if (data['pid']) {
                    const regex = /^\d{13}$/;
                    if (!regex.test(data['pid'])) {
                      return alert('กรุณาตรวจสอบเลขบัตรประชาชน')
                    }
                  }

                  if (!data['phone']) {
                    return alert('กรุณากรอกเบอร์โทรศัพท์')
                  }
                  if (data['phone']) {
                    const regex = /^\d{10}$/;
                    if (!regex.test(data['phone'])) {
                      return alert('กรุณาตรวจสอบเบอร์โทรศัพท์')
                    }
                  }
                  handleButton("2");
                  // }
                }}
              >
                เริ่มประเมิน
              </Button>
            </Box>
          </Box>
        ) : null}

        {location.state.button === "2" ? (
          <Box
            sx={{
              display: "grid",
              gridGap: "20px",
              marginTop: "20px",
            }}
          >
            <Box
              sx={{
                fontWeight: 600,
                "@media (max-width: 800px)": {
                  fontSize: "14px",
                },
              }}
            >ส่วนที่ 2 : แบบประเมินพลังใจ (RQ)</Box>
            <Box sx={{ margin: "0 20px" }}>
              <Typography
                sx={{
                  "@media (max-width: 800px)": {
                    fontSize: "12px",
                  },
                }}
              >
                ในช่วง2 สัปดาห์ที่ผ่านมา ท่านมีความเชื่อมั่นในประเด็นต่าง ๆ
                ต่อไปนี้เพียงใด
              </Typography>
              <Typography
                sx={{
                  "@media (max-width: 800px)": {
                    fontSize: "12px",
                  },
                }}
              >
                คะแนนตั้งแต่ 1-10 โดย "1 หมายถึง เชื่อมั่นน้อย และ 10 หมายถึง
                เชื่อมั่นมาก"
              </Typography>
            </Box>
            <Box
              sx={{
                border: "1px solid #AEB4DD",
                borderRadius: "5px",
                padding: "20px",
                textAlign: "center",
                display: "grid",
                gridGap: "20px",
              }}
            >
              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    "@media (max-width: 800px)": {
                      fontSize: "12px",
                    },
                  }}
                >1) ฉันเอาชนะอุปสรรคปัญหาต่าง ๆ ในชีวิตได้</Typography>
                <Box
                  sx={{
                    display: "flex",
                    gridGap: "20px",
                    justifyContent: "center",
                    "@media (max-width: 800px)": {
                      fontSize: "12px",
                      display: "grid",
                      gridGap: 0,
                    },
                  }}
                >
                  <Box>เชื่อมั่นน้อย</Box>
                  <StyledRating
                    name="customized-color"
                    max={10}
                    icon={<CircleIcon fontSize="small" />}
                    emptyIcon={<CircleIcon fontSize="small" />}
                    value={evaluate_rq1}
                    onChange={(event, newValue) => {
                      setEvaluate_rq1(newValue);
                    }}
                  />
                  <Box>เชื่อมั่นมาก</Box>
                </Box>
              </Box>

              <Box sx={{ padding: "0 10px" }}>
                <Box sx={{ border: "1px solid #EBEFF2" }}></Box>
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    "@media (max-width: 800px)": {
                      fontSize: "12px",
                    },
                  }}
                >
                  2) ฉันมีกำลังใจและได้รับการสนับสนุนจากคนรอบข้าง
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    gridGap: "20px",
                    justifyContent: "center",
                    "@media (max-width: 800px)": {
                      fontSize: "12px",
                      display: "grid",
                      gridGap: 0,
                    },
                  }}
                >
                  <Box>เชื่อมั่นน้อย</Box>
                  <StyledRating
                    name="customized-color"
                    max={10}
                    icon={<CircleIcon fontSize="small" />}
                    emptyIcon={<CircleIcon fontSize="small" />}
                    value={evaluate_rq2}
                    onChange={(event, newValue) => {
                      setEvaluate_rq2(newValue);
                    }}
                  />
                  <Box>เชื่อมั่นมาก</Box>
                </Box>
              </Box>

              <Box sx={{ padding: "0 10px" }}>
                <Box sx={{ border: "1px solid #EBEFF2" }}></Box>
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    "@media (max-width: 800px)": {
                      fontSize: "12px",
                    },
                  }}
                >
                  3) ฉันจัดการกับปัญหาและความเครียดของตนเองได้
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    gridGap: "20px",
                    justifyContent: "center",
                    "@media (max-width: 800px)": {
                      fontSize: "12px",
                      display: "grid",
                      gridGap: 0,
                    },
                  }}
                >
                  <Box>เชื่อมั่นน้อย</Box>
                  <StyledRating
                    name="customized-color"
                    max={10}
                    icon={<CircleIcon fontSize="small" />}
                    emptyIcon={<CircleIcon fontSize="small" />}
                    value={evaluate_rq3}
                    onChange={(event, newValue) => {
                      setEvaluate_rq3(newValue);
                    }}
                  />
                  <Box>เชื่อมั่นมาก</Box>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gridGap: "20px",
                "@media (max-width: 800px)": {
                  display: "grid",
                },
              }}
            >
              <Button
                variant="contained"
                sx={{
                  width: "150px",
                  "@media (max-width: 800px)": {
                    width: "100px",
                  },
                }}
                onClick={() => {
                  if (!evaluate_rq1) {
                    return alert('กรุณาทำแบบประเมินพลังใจข้อที่ 1')
                  }
                  if (!evaluate_rq2) {
                    return alert('กรุณาทำแบบประเมินพลังใจข้อที่ 2')
                  }
                  if (!evaluate_rq3) {
                    return alert('กรุณาทำแบบประเมินพลังใจข้อที่ 3')
                  }
                  handleButton("3");
                }}
              >
                ถัดไป
              </Button>
            </Box>
          </Box>
        ) : null}

        {location.state.button === "3" ? (
          <Box
            sx={{
              display: "grid",
              gridGap: "20px",
              marginTop: "20px",
            }}
          >
            <Box sx={{
              fontWeight: 600,
              "@media (max-width: 800px)": {
                fontSize: "14px",
              },
            }}>
              ส่วนที่ 3 : แบบประเมินอาการเหนื่อยล้า หมดไฟ (Burnout)
            </Box>
            <Box sx={{ margin: "0 20px" }}>
              <Typography sx={{
                "@media (max-width: 800px)": {
                  fontSize: "12px",
                },
              }}>
                โปรดอ่านข้อความแต่ละข้อให้เข้าใจ
                และตัดสินใจว่าท่านเคยมีความรู้สึกเช่นนี้กับการทำงานของท่านและเลือกช่องที่ตรงกับความรู้สึกของท่านมากที่สุดเพียงคำตอบเดียว
                ดังนี้
              </Typography>
            </Box>
            <Box
              sx={{
                border: "1px solid #AEB4DD",
                borderRadius: "5px",
                padding: "20px",
              }}
            >
              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                "@media (max-width: 800px)": {
                  gridTemplateColumns: '1fr'
                },
              }}>
                <Box></Box>
                <Box sx={{
                  fontWeight: 600,
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  textAlign: 'center',
                  color: '#478F96',
                  "@media (max-width: 800px)": {
                    padding: '10px 0',
                    fontSize: "14px",
                  },
                }}>
                  <Box>แทบไม่มี</Box>
                  <Box>เป็นบางครั้ง</Box>
                  <Box>บ่อยครั้ง</Box>
                  <Box>เป็นประจำ</Box>
                </Box>
              </Box>

              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                alignItems: 'center',
                "@media (max-width: 800px)": {
                  gridTemplateColumns: '1fr',
                  textAlign: 'center',
                  fontSize: '12px'
                },
              }}>
                <Box>1) ท่านรู้สึกอ่อนล้าทางจิตใจ</Box>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  textAlign: 'center'
                }}>
                  {optionalList.map((item, index) => (
                    <GreenRadio
                      key={index}
                      checked={evaluate_burnout1 === item}
                      onChange={() => { setEvaluate_burnout1(item); }}
                      value={evaluate_burnout1}
                      name="radio-button-demo"
                    />
                  ))}
                </Box>
              </Box>

              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                alignItems: 'center',
                "@media (max-width: 800px)": {
                  gridTemplateColumns: '1fr',
                  textAlign: 'center',
                  fontSize: '12px'
                },
              }}>
                <Box>2) ท่านรู้สึกขาดแรงใจ/ ความกระตือรือร้น</Box>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  textAlign: 'center'
                }}>
                  {optionalList.map((item, index) => (
                    <GreenRadio
                      key={index}
                      checked={evaluate_burnout2 === item}
                      onChange={() => { setEvaluate_burnout2(item); }}
                      value={evaluate_burnout2}
                      name="radio-button-demo"
                    />
                  ))}
                </Box>
              </Box>

              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                alignItems: 'center',
                "@media (max-width: 800px)": {
                  gridTemplateColumns: '1fr',
                  textAlign: 'center',
                  fontSize: '12px'
                },
              }}>
                <Box>3) ท่านรู้สึกไม่ดีกับคนรอบข้าง</Box>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  textAlign: 'center'
                }}>
                  {optionalList.map((item, index) => (
                    <GreenRadio
                      key={index}
                      checked={evaluate_burnout3 === item}
                      onChange={() => { setEvaluate_burnout3(item); }}
                      value={evaluate_burnout3}
                      name="radio-button-demo"
                    />
                  ))}
                </Box>
              </Box>

              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                alignItems: 'center',
                "@media (max-width: 800px)": {
                  gridTemplateColumns: '1fr',
                  textAlign: 'center',
                  fontSize: '12px'
                },
              }}>
                <Box>4) ท่านรู้สึกไม่อยากสนใจคนรอบข้าง</Box>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  textAlign: 'center'
                }}>
                  {optionalList.map((item, index) => (
                    <GreenRadio
                      key={index}
                      checked={evaluate_burnout4 === item}
                      onChange={() => { setEvaluate_burnout4(item); }}
                      value={evaluate_burnout4}
                      name="radio-button-demo"
                    />
                  ))}
                </Box>
              </Box>

              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                alignItems: 'center',
                "@media (max-width: 800px)": {
                  gridTemplateColumns: '1fr',
                  textAlign: 'center',
                  fontSize: '12px'
                },
              }}>
                <Box>5) ท่านรู้สึกไม่มีความสุขในการทำงาน</Box>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  textAlign: 'center'
                }}>
                  {optionalList.map((item, index) => (
                    <GreenRadio
                      key={index}
                      checked={evaluate_burnout5 === item}
                      onChange={() => { setEvaluate_burnout5(item); }}
                      value={evaluate_burnout5}
                      name="radio-button-demo"
                    />
                  ))}
                </Box>
              </Box>

              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                alignItems: 'center',
                "@media (max-width: 800px)": {
                  gridTemplateColumns: '1fr',
                  textAlign: 'center',
                  fontSize: '12px'
                },
              }}>
                <Box>6) ท่านรู้สึกไม่ประสบความสำเร็จเท่าที่ควร</Box>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  textAlign: 'center'
                }}>
                  {optionalList.map((item, index) => (
                    <GreenRadio
                      key={index}
                      checked={evaluate_burnout6 === item}
                      onChange={() => { setEvaluate_burnout6(item); }}
                      value={evaluate_burnout6}
                      name="radio-button-demo"
                    />
                  ))}
                </Box>
              </Box>

            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center"
              }}
            >
              <Button
                variant="contained"
                sx={{
                  width: "150px",
                  "@media (max-width: 800px)": {
                    width: "100px",
                  },
                }}
                onClick={() => {
                  if (!evaluate_burnout1) {
                    return alert('กรุณาทำแบบประเมินอาการเหนื่อยล้า หมดไฟ ข้อที่ 1')
                  }
                  if (!evaluate_burnout2) {
                    return alert('กรุณาทำแบบประเมินอาการเหนื่อยล้า หมดไฟ ข้อที่ 2')
                  }
                  if (!evaluate_burnout3) {
                    return alert('กรุณาทำแบบประเมินอาการเหนื่อยล้า หมดไฟ ข้อที่ 3')
                  }
                  if (!evaluate_burnout4) {
                    return alert('กรุณาทำแบบประเมินอาการเหนื่อยล้า หมดไฟ ข้อที่ 4')
                  }
                  if (!evaluate_burnout5) {
                    return alert('กรุณาทำแบบประเมินอาการเหนื่อยล้า หมดไฟ ข้อที่ 5')
                  }
                  if (!evaluate_burnout6) {
                    return alert('กรุณาทำแบบประเมินอาการเหนื่อยล้า หมดไฟ ข้อที่ 6')
                  }
                  handleButton("4");
                }}
              >
                ถัดไป
              </Button>
            </Box>
          </Box>
        ) : null}

        {location.state.button === "4" ?
          <Box
            sx={{
              display: "grid",
              gridGap: "20px",
              marginTop: "20px",
            }}
          >
            <Box sx={{
              fontWeight: 600,
              "@media (max-width: 800px)": {
                fontSize: "14px",
              },
            }}>
              ส่วนที่ 4 : แบบประเมินความเครียด 5 ข้อ (ST- 5)
            </Box>
            <Box sx={{ margin: "0 20px" }}>
              <Typography sx={{
                "@media (max-width: 800px)": {
                  fontSize: "12px",
                },
              }}>
                ให้ระบุอาการหรือความรู้สึกที่เกิดขึ้นในระยะ 2-4 สัปดาห์ที่ผ่านมา
              </Typography>
            </Box>
            <Box
              sx={{
                border: "1px solid #AEB4DD",
                borderRadius: "5px",
                padding: "20px",
              }}
            >
              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                "@media (max-width: 800px)": {
                  gridTemplateColumns: '1fr'
                },
              }}>
                <Box></Box>
                <Box sx={{
                  fontWeight: 600,
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  textAlign: 'center',
                  color: '#478F96',
                  "@media (max-width: 800px)": {
                    padding: '10px 0',
                    fontSize: "14px",
                  },
                }}>
                  <Box>แทบไม่มี</Box>
                  <Box>เป็นบางครั้ง</Box>
                  <Box>บ่อยครั้ง</Box>
                  <Box>เป็นประจำ</Box>
                </Box>
              </Box>

              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                alignItems: 'center',
                "@media (max-width: 800px)": {
                  gridTemplateColumns: '1fr',
                  textAlign: 'center',
                  fontSize: '12px'
                },
              }}>
                <Box>1) มีปัญหาการนอน นอนไม่หลับ หรือนอนมาก</Box>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  textAlign: 'center'
                }}>
                  {optionalListSt5.map((item, index) => (
                    <GreenRadio
                      key={index}
                      checked={evaluate_st1 === item}
                      onChange={() => { setEvaluate_st1(item); }}
                      value={evaluate_st1}
                      name="radio-button-demo"
                    />
                  ))}
                </Box>
              </Box>

              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                alignItems: 'center',
                "@media (max-width: 800px)": {
                  gridTemplateColumns: '1fr',
                  textAlign: 'center',
                  fontSize: '12px'
                },
              }}>
                <Box>2) มีสมาธิน้อยลง</Box>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  textAlign: 'center'
                }}>
                  {optionalListSt5.map((item, index) => (
                    <GreenRadio
                      key={index}
                      checked={evaluate_st2 === item}
                      onChange={() => { setEvaluate_st2(item); }}
                      value={evaluate_st2}
                      name="radio-button-demo"
                    />
                  ))}
                </Box>
              </Box>

              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                alignItems: 'center',
                "@media (max-width: 800px)": {
                  gridTemplateColumns: '1fr',
                  textAlign: 'center',
                  fontSize: '12px'
                },
              }}>
                <Box>3) หงุดหงิด กระวนกระวาย ว้าวุ่นใจ</Box>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  textAlign: 'center'
                }}>
                  {optionalListSt5.map((item, index) => (
                    <GreenRadio
                      key={index}
                      checked={evaluate_st3 === item}
                      onChange={() => { setEvaluate_st3(item); }}
                      value={evaluate_st3}
                      name="radio-button-demo"
                    />
                  ))}
                </Box>
              </Box>

              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                alignItems: 'center',
                "@media (max-width: 800px)": {
                  gridTemplateColumns: '1fr',
                  textAlign: 'center',
                  fontSize: '12px'
                },
              }}>
                <Box>4) รู้สึกเบื่อหน่าย เซ็ง</Box>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  textAlign: 'center'
                }}>
                  {optionalListSt5.map((item, index) => (
                    <GreenRadio
                      key={index}
                      checked={evaluate_st4 === item}
                      onChange={() => { setEvaluate_st4(item); }}
                      value={evaluate_st4}
                      name="radio-button-demo"
                    />
                  ))}
                </Box>
              </Box>

              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                alignItems: 'center',
                "@media (max-width: 800px)": {
                  gridTemplateColumns: '1fr',
                  textAlign: 'center',
                  fontSize: '12px'
                },
              }}>
                <Box>5) ไม่อยากพบปะผู้คน</Box>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  textAlign: 'center'
                }}>
                  {optionalListSt5.map((item, index) => (
                    <GreenRadio
                      key={index}
                      checked={evaluate_st5 === item}
                      onChange={() => { setEvaluate_st5(item); }}
                      value={evaluate_st5}
                      name="radio-button-demo"
                    />
                  ))}
                </Box>
              </Box>

            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center"
              }}
            >
              <Button
                variant="contained"
                sx={{
                  width: "150px",
                  "@media (max-width: 800px)": {
                    width: "100px",
                  },
                }}
                onClick={() => {
                  if (evaluate_st1 === null) {
                    return alert('กรุณาทำแบบประเมินความเครียดข้อที่ 1')
                  }
                  if (evaluate_st2 === null) {
                    return alert('กรุณาทำแบบประเมินความเครียดข้อที่ 2')
                  }
                  if (evaluate_st3 === null) {
                    return alert('กรุณาทำแบบประเมินความเครียดข้อที่ 3')
                  }
                  if (evaluate_st4 === null) {
                    return alert('กรุณาทำแบบประเมินความเครียดข้อที่ 4')
                  }
                  if (evaluate_st5 === null) {
                    return alert('กรุณาทำแบบประเมินความเครียดข้อที่ 5')
                  }

                  saveAssessment()
                }}
              >
                บันทึก
              </Button>
            </Box>
          </Box>
          : null}
      </Box>
    </>
  );
}

export default MentalHealthAssessment;
